(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('siteRemoveAction', {
      controller: Controller,
      templateUrl: 'actions/site/remove/remove-site.action.html',
      bindings: {
        siteId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
